export enum OS {
    ios,
    android,
    windows,
    unknown,
}
